// eslint-disable-next-line no-unused-vars
export default function preloaderHelp (scene) {

    scene.load.image(`cancel`, `/img/generalSprites/cancel.png`);
    scene.load.image(`menu-pause`, `/img/menu-pause.png`);


}